import React from 'react';
import { Link } from 'react-router';
import { get } from 'lodash';
import { Col, Row } from 'react-bootstrap';
import { InfoLabel } from '../../../../../../common/components';
import displayName from '../../../../../../helpers/displayName';
import getStatus from '../../../../../../schemas/policy';
import { isOwner } from '../../../../../auth/redux/authActions';

const getRenewalStatus = (policyNumber, quoteType, policyStatus, resourceStatus) => {
  if (policyNumber) {
    return resourceStatus;
  }
  if (quoteType === 'renewal') {
    return policyStatus;
  }
  return '';
};

const PersonalAccidentSummary = ({ resource, policy, quoteDate }) => {
  const isAnnual = resource.metadata.scheme_type === 'annual';

  const renewalStatus = isAnnual
    ? getRenewalStatus(
        resource.policy_number,
        resource.quote_type,
        policy.data.attributes.renewal_status,
        resource.renewal_status,
      )
    : '';

  return (
    <div className="summary-section">
      <Row>
        <Col sm={12} className="section-title">
          <h4>Summary</h4>
        </Col>
        <Col sm={6}>
          <InfoLabel
            label="Product"
            value={get(resource, 'product_name')}
            labelSize={4}
            wrapperClass={'clear-margin'}
          />
          {get(policy, 'data.attributes') && (
            <InfoLabel
              labelSize={4}
              label="Policy"
              value={
                <Link to={'/policies/issued/' + policy.data.id} onlyActiveOnIndex>
                  {policy.data.attributes.policy_number +
                    ' (' +
                    getStatus(policy.data.attributes.status) +
                    ')'}
                </Link>
              }
              //wrapperClass={'clear-margin'}
            />
          )}
          <InfoLabel
            label="Start Date"
            date
            value={get(resource, 'starts_at', get(resource, 'commences_at'))}
            labelSize={4}
            wrapperClass={'clear-margin'}
          />
          <InfoLabel
            label="End Date"
            date
            value={resource.expires_at || resource.ends_at}
            labelSize={4}
            wrapperClass={'clear-margin'}
          />

          <InfoLabel
            label="Group Type"
            value={displayName(get(resource, 'metadata.group_type'), true)}
            labelSize={4}
            wrapperClass={'clear-margin'}
          />
        </Col>
        <Col sm={6}>
          <InfoLabel
            label="Channel"
            value={get(resource, 'channel_name')}
            labelSize={4}
            wrapperClass={'clear-margin'}
          />
          <InfoLabel
            label="Quote Date"
            date
            value={quoteDate}
            labelSize={4}
            wrapperClass={'clear-margin'}
          />
          <InfoLabel
            label="Issue Date"
            date
            value={resource.issued_at}
            labelSize={4}
            wrapperClass={'clear-margin'}
          />

          {isOwner() && (
            <InfoLabel
              label="Last Updated Date"
              dateTime
              value={resource.updated_at}
              labelSize={4}
              wrapperClass={'clear-margin'}
            />
          )}

          {renewalStatus && (
            <div>
              <InfoLabel label="Renewal Status" value={renewalStatus} labelSize={4} />
            </div>
          )}
          {isAnnual && resource.policy_number && (
            <div>
              <InfoLabel label="Term Number" value={resource.term_number} labelSize={4} />
            </div>
          )}
        </Col>
      </Row>
      <div className="hr" />
    </div>
  );
};

export default PersonalAccidentSummary;
